import config from 'config';

export const APPLICATION_STATE = 'APPLICATION';

export const NOTICE_TYPES = {
  error: 'error',
  warning: 'warning',
  success: 'success'
} as const;

export const MODALS = {
  navigationHistoryFilter: 'navigationHistoryFilter',
  navigationHistory: 'navigationHistory',
  stationsFilter: 'stationsFilter',
  station: 'station',
  route: 'route',
  clientSettings: 'clientSettings',
  logIn: 'logIn',
  reportsWindow: 'reportsWindow',
  reportsWindowContent: 'reportsWindowContent',
  driverLocationsAttention: 'driverLocationsAttention',
  driverLocations: 'driverLocations',
  carEBoxLocations: 'carEBoxLocations',
  carEBoxLocationsClientCards: 'carEBoxLocationsClientCards',
  carLocationSharing: 'carLocationSharing',
  carLocationSharingHistory: 'carLocationSharingHistory',
  clientCars: 'clientCars',
  favouriteStations: 'favouriteStations',
  driverFuelAssignments: 'driverFuelAssignments',
  addDriverFuelAssignments: 'addDriverFuelAssignments',
  deleteDriverFuelAssignments: 'deleteDriverFuelAssignments',
  stationsPriceReport: 'stationsPriceReport',
  stationsPriceReportMobileFilter: 'stationsPriceReportMobileFilter',
  stationsPriceReportMobileSorting: 'stationsPriceReportMobileSorting',
  stationsPriceReportSettings: 'stationsPriceReportSettings',
  map: 'map',
  reports: 'reports',
} as const;

export const URL_PARAMS = {
  boundCountries: 'bound-countries',
  activeStation: 'active-station'
} as const;

export const FEATURE_FLAGS = {
  fuelTasks: 'FuelTasks',
  priceReport: 'PriceReport'
} as const;

export const IS_ACTIVE_CONTOUR_A = window.location.origin === config.contourA;
export const IS_ACTIVE_CONTOUR_B = window.location.origin === config.contourB;

export const IS_DIFFERENT_CONTOURS = config.contourA !== config.contourB;

export const IS_WINDOW_IFRAME = window.self !== window.top;

const currentURL = document.referrer ? new URL(document.referrer) : { origin: '' };

export const IS_PARENT_WINDOW_CONTOUR_A = window.self !== window.top &&
  currentURL.origin === config.contourA;

export const IS_WINDOW_IFRAME_FROM_UNKNOWN_RESOURCE =
  window.self !== window.top &&
  currentURL.origin !== config.contourA &&
  currentURL.origin !== config.contourB;

export const IOS_STORE_URL = 'https://apps.apple.com/by/app/e100-mobile/id1522891736';
export const ANDROID_STORE_URL = 'https://play.google.com/store/apps/details?id=eu.e100.e100app';
export const E100_MOBILE_APPLICATION_URL = 'https://e100.eu/en/tools/mobile-application';